export const finance_crypto = [
  { char: '🪙', name: 'Coin', nameZh: '加密貨幣', keywords: ['crypto', 'btc', 'eth'], hot: true },
  { char: '💹', name: 'Chart Up with Yen', nameZh: '殖利率/獲利', keywords: ['profit', 'stock', 'dividend'], hot: true },
  { char: '📉', name: 'Chart Down', nameZh: '風險控管', keywords: ['risk', 'bear', 'loss'] },
  { char: '🏦', name: 'Bank', nameZh: '資產配置', keywords: ['bank', 'save', 'asset'] },
  { char: '💳', name: 'Credit Card', nameZh: '消費金融', keywords: ['pay', 'card', 'finance'] },
  { char: '⛓️', name: 'Chains', nameZh: '區塊鏈技術', keywords: ['blockchain', 'web3', 'decentralized'] },
  { char: '🔒', name: 'Lock', nameZh: '冷錢包/安全', keywords: ['wallet', 'secure', 'cold'] },
  { char: '💎', name: 'Gem', nameZh: '藍籌股/虛寶', keywords: ['blue', 'gem', 'value'] },
  { char: '💼', name: 'Briefcase', nameZh: '投資組合', keywords: ['portfolio', 'invest', 'work'] },
  { char: '⚖️', name: 'Balance', nameZh: '合規與法律', keywords: ['law', 'compliance', 'legal'] },
  { char: '💸', name: 'Flying Money', nameZh: '資金流動', keywords: ['cash', 'flow', 'spend'] },
  { char: '🧾', name: 'Receipt', nameZh: '稅務報表', keywords: ['tax', 'report', 'paper'] },
];